import Button from 'components/ui-components/Button';
import { CrossIcon } from 'assets/icons';

const QuickOrdersRemoveIcon = ({ action, cn, height, width, disabled }) => (
  <Button
    className="quick-orders__hidden-button"
    label="Remove order"
    disabled={disabled}
    handleClick={() => action()}>
    <CrossIcon
      className={cn}
      fillColor="#60686C"
      height={height}
      width={width}
    />
  </Button>
);

export default QuickOrdersRemoveIcon;
